import React, { useRef, useState } from "react";
import Modal from "../../../../components/common/form/Modal";
import Button from "../../../../components/common/form/Button";

interface FailedPaymentsModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    responseObj: any;
}

const FailedPaymentsModal: React.FC<FailedPaymentsModalProps> = ({ show, setShow, responseObj }) => {

    const dismissModal = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setShow(false);
    };

    return (
        <Modal
            title={"Bulk Action Complete"}
            show={show}
            setShow={setShow}
            className={"w-3/6 bg-text-0 text-surface-0"}
            fields={
                <>
                    <div className="modal-body modal_body_height">
                        <div className="mt-2 pl-3">
                            <div><b>Total Orders: {responseObj?.totalOrders ?? 0}</b></div>
                            <div><b>Order Not Found: {responseObj?.ordersNotFound ?? 0}</b></div>
                            <table className="table table-striped table-hover scroll table-width" id="closeOrder">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col" className="nav-container-bg">Customer Order Number</th>
                                        <th scope="col" className="nav-container-bg">Failure Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(responseObj?.failureOrders).map((key) => (
                                        <tr key={key}>
                                            <td>{key}</td>
                                            <td>{responseObj?.failureOrders[key]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button btnText="Close" type="submit" className="cursor btn cm_btn" onClick={dismissModal} />

                    </div>
                </>
            }
        />

    )
};

export default FailedPaymentsModal;
